<template>
<span>
  <template v-for='practitioner in practitioners' >
    <slot></slot>
    <v-tooltip
      v-if='practitioner'
      :key='practitioner.id' top >
      <template v-slot:activator="{ on }">
        <v-avatar
          v-on="on"
          :size='size' color='grey' class='ml-1 elevation-4' >
          <v-img lazy
            v-if='avatarUrl(practitioner)'
            :src='avatarUrl(practitioner)'  >
          </v-img>
          <span class='white--text' v-else >
            <template v-if='practitioner && practitioner.full_name' >
              {{ practitioner.full_name[0] }}
            </template>
          </span>
        </v-avatar>
        <v-chip
          v-if='withAdd'
          @click.stop='$emit("add")'
          outline outlined color='primary' :size='size' >
          <v-icon small >add</v-icon>
        </v-chip>
      </template>
      <span>{{ getTitle(practitioner) }}</span>
    </v-tooltip>
  </template>
  <!-- <v-dialog v-model='showPicker' >
    <v-card>
      <v-card-title class='subtitle-1 overline' >
      </v-card-title>
      <v-card-text>
        <space-picker :value='selectedSpaces' return-object >
        </space-picker>
      </v-card-text>
    </v-card>
  </v-dialog> -->
</span>
</template>
<script>
export default {
  props: {
    practitionerIds: { type: Array },
    size: { type: Number, default: 28 },
    withAdd: { type: Boolean, default: false },
    tooltipPrefix: { type: String }
  },
  name: 'PractitionerFaces',
  data () {
    return {
      showPicker: false
    }
  },
  methods: {
    getTitle (practitioner) {
      if (!practitioner) { return '' }
      if (this.tooltipPrefix) {
        return `${this.tooltipPrefix} ${practitioner.full_name}`
      }
      return practitioner.full_name
    },
    avatarUrl (practitioner) {
      let url = this.getObjectPath(practitioner, 'profile_picture')
      return this.imageKitUrl(url, 'n-avatar')
    }
  },
  computed: {
    practitioners () {
      return this.practitionerIds.map((practitionerId) => {
        return this.$store.getters.getPractitionerById(practitionerId)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// PractitionerFaces.vue?7296b76a